import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const getDashboardLink = () => {
    if (!user) return '/login';
    // Role ID mapping: 1=Super Admin, 2=Admin, 3=Participant, 4=Individual
    const roleRoutes = {
      1: '/admin-dashboard', // Super Admin uses admin dashboard
      2: '/admin-dashboard',
      3: '/participant-dashboard',
      4: '/individual-dashboard',
    };
    return roleRoutes[user.activeRoleId] || '/admin-dashboard';
  };

  return (
    <>
      <header className="main-header">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            <Link className="navbar-brand" to="/">
              <img src="/images/logo_image.webp" alt="FundMeWiz" />
            </Link>

            <button 
              className="navbar-toggler" 
              type="button"
              onClick={() => setShowMobileMenu(!showMobileMenu)}
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse ${showMobileMenu ? 'show' : ''}`}>
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link className="nav-link" to="/">Home</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/about-us">About Us</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/contact-us">Contact</Link>
                </li>
              </ul>

              <div className="auth-buttons ms-lg-3">
                {isAuthenticated ? (
                  <div className="dropdown user-dropdown">
                    <button 
                      className="btn dropdown-toggle" 
                      type="button" 
                      data-bs-toggle="dropdown"
                    >
                      <img 
                        src={user?.profileImage || '/images/profile_img.webp'} 
                        alt={user?.firstName} 
                        className="user-avatar"
                      />
                      <span className="user-name d-none d-lg-inline">
                        {user?.firstName} {user?.lastName}
                      </span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <Link className="dropdown-item" to={getDashboardLink()}>
                          <i className="fas fa-tachometer-alt"></i> Dashboard
                        </Link>
                      </li>
                      <li><hr className="dropdown-divider" /></li>
                      <li>
                        <button className="dropdown-item" onClick={handleLogout}>
                          <i className="fas fa-sign-out-alt"></i> Logout
                        </button>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <>
                    <Link to="/login" className="btn btn-login">Sign In</Link>
                    <Link to="/register" className="btn btn-signup">Start Campaign</Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </nav>
      </header>

      {showMobileMenu && (
        <div className="mobile-menu-overlay show" onClick={() => setShowMobileMenu(false)} />
      )}
    </>
  );
};

export default Header;
